/**
 * Swiper js for collection swiper
 **/

class SwiperSlider extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.nextEl = this.querySelector('.swiper-button-next');
    this.prevEl = this.querySelector('.swiper-button-prev');
    const swiper = new Swiper(this, {
      loop: true,
      slidesPerView: 3,
      spaceBetween: 16,
      allowTouchMove: true,
      mouseWheel: true,
      breakpoints: {
        320: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
        480: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
        640: {
          slidesPerView: 3,
          spaceBetween: 16,
        },
      },
      navigation: {
        nextEl: this.nextEl,
        prevEl: this.prevEl,
      },
    });
  }
}

customElements.define('swiper-slider', SwiperSlider);
